import { useGraphqlDelete } from "@harea/component"

export const useDayOffDeleteMutation = () => {
  return useGraphqlDelete('timeoff')
}
